import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';
import cx from '@/utils/cx';
import useStyle from './style';

const Num = (n, k) => (
  <span className="number-part" key={`number-${k}`}>
    {n}
  </span>
);
const faNum = (str) => str ? str.toString().split('').map((num) => String.fromCharCode(num.charCodeAt(0) + 1728)) : [];
const engNum = (str) => str ? str.toString().split('') : [];

const VehiclePlate = ({
  plate,
  iconsBaseUrl,
  className,
  ...rest
}) => {
  const theme = useTheme();
  const classes = useStyle();

  const calculatedIconsBaseUrl = iconsBaseUrl || theme.defaultVehiclePlateIconsBaseUrl;
  const plateType = plate.part_a && plate.part_a.toString().length === 3 ? 'motorcycle' : (['private', 'freezone-old', 'freezone-new'][Math.floor(plate.type / 1000)]);
  const iranId = plate.iran_id && plate.iran_id;
  const isFreeZone = plateType.startsWith('freezone');
  const zoneId = plate.type % 1000;
  const isPrivate = plateType === 'private';

  return (
    <div
      className={cx(
        classes.vehiclePlate,
        plateType,
        className,
      )}
      {...rest}
    >
      {isFreeZone && (
        <img className="freezone-img" src={`${calculatedIconsBaseUrl}/zone-${zoneId}.png`} alt="zone" />
      )}
      <div className="number">
        <span className="part-a">
          <div className="iran-flag">
            <div className="green" />
            <div className="white"> $ </div>
            <div className="red" />
          </div>
          {faNum(plate.part_a).map(Num)}
        </span>
        {isPrivate && (
          <span className="character">
            {plate.character}
          </span>
        )}
        <span className={cx('part-b', { [classes.enFont]: isFreeZone })}>
          {isFreeZone && engNum(plate.part_a).map(Num)}
          {!!plate.part_b && faNum(plate.part_b).map(Num)}
        </span>
      </div>
      {!!iranId && (<span className="sep" />)}
      {!!iranId && (
        <div className="iran-id">
          {!isFreeZone && (
            <div className="iran">ایــران</div>
          )}
          <div className="id">{faNum(iranId).map(Num)}</div>
          {isFreeZone && (
            <div className={cx('id', classes.enFont)}>{engNum(iranId).map(Num)}</div>
          )}
        </div>
      )}
    </div>
  );
};


VehiclePlate.propTypes = {
  plate: PropTypes.shape({
    type: PropTypes.oneOf([
      1,
      1001,
      1002,
      1003,
      1004,
      1005,
      1006,
      1007,
      2001,
      2002,
      2003,
      2004,
      2005,
      2006,
      2007,
    ]),
    part_a: PropTypes.number,
    character: PropTypes.string,
    part_b: PropTypes.number,
    iran_id: PropTypes.number,
  }),
  /**
   * Base URL of plaet icons.
   * By defaults it will use "defaultVehiclePlateIconsBaseUrl" prop of `ThemeProvider` component.
  */
  iconsBaseUrl: PropTypes.string,
  className: PropTypes.string,
};

VehiclePlate.defaultProps = {
  plate: {
    type: 1,
    part_a: 132,
    character: 'ک',
    part_b: 36845,
    iran_id: 11,
  },
  iconsBaseUrl: '',
  className: '',
};

export default VehiclePlate;
